import { RouteComponentProps } from 'react-router'
import * as React from 'react'
import './styles.css'

export default function Breadcrumb({ match }: RouteComponentProps<{}>) {
    const page = match.url.startsWith('/projects')
        ? 'Projects'
        : match.url.startsWith('/faq')
            ? 'F.A.Q'
            : null

    return page
        ? <h1 className='v-breadcrumb'>{page}</h1>
        : null
}


// WEBPACK FOOTER //
// ./src/components/Breadcrumb/index.tsx